<template>
  <div>
    <v-row>
      <v-col cols="6" class="pt-2 pb-0 mb-n4">
        <v-text-field class="input-text-size pa-0 pt-1"
        v-model="editedItem.taxYear" readonly dense label="Tax Year" />
      </v-col>
      <v-col cols="6" class="pt-2 pb-0 mb-n4">
        <v-text-field class="input-text-size pa-0 pt-1"
        v-model="editedItem.taxId" readonly label="Tax ID" dense />
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mb-n4 mt-n2">
        <CommonDropDowns class="pt-1" :isCommentsCategoryReadonly=true
        :isItCategory=true @change="dataFromCommonDropDowns"
        :commentsCategoryValue="editedItem.category" />
      </v-col>
      <v-col cols="6" class="pt-2 pb-0 mb-n4 mt-n2">
        <v-autocomplete :items="reasonListDropDown" class="input-text-size" label='Reason Code'
         v-model="editedItem.reasonCode" item-text="name" item-value="value" readonly />
      </v-col>
      <v-col cols="4" class="pt-2 pb-0">
        <v-checkbox v-model="editedItem.addToLegal"
        class="input-text-size" readonly label="Add To Legal" />
      </v-col>
      <v-col cols="4" class="pl-3 pa-0 mt-2">
        <v-checkbox class="input-text-size"
        v-model="editedItem.sendToWebsite" readonly label="Send To Website" />
      </v-col>
      <v-col cols="4" class="pl-3 pa-0 mt-8">
        <v-checkbox class="input-text-size mt-n2" v-model="editedItem.rollToNextYear" readonly
          label="Roll To Next Year" />
      </v-col>
      <v-col cols="12">
        <v-textarea
         class="input-text-size pa-0 mb-n5"
        outlined rows="3"
        v-model="editedItem.comment"
        v-textAreaUppercase=globalSettingItem.conEverythingToCaps
        readonly
        label="Comments"
        >
        </v-textarea>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapState,
}
  from 'vuex';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'commentDialog',
  mixins: [GlobalToCaps],
  components: {
    CommonDropDowns,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'taxComments',
    },
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'items', 'index', 'isVisible']),
    ...mapState({
      taxYearList: (state) => state.tax.taxCommon.taxYearList,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      reasonListDropDown: (state) => state.base.crud.items.reasonListDropDown,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },

  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
    dataFromCommonDropDowns(val, whichField) {
      this.editedItem[whichField] = val;
    },
  },
};
</script>
